import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSearch, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Projects.css';
import um from '../../img/Manutencao/1.jpg';
import dois from '../../img/Manutencao/2.png';
import tres from '../../img/Manutencao/3.jpg';
import quatro from '../../img/Manutencao/4.jpg';

import umti from '../../img/ti/1.jpg';
import doisti from '../../img/ti/2.jpg';
import tresti from '../../img/ti/3.jpg';
import quatroti from '../../img/ti/4.avif';

const manutencaoImages = [
  { src: um, title: 'Cabeamento de redes- Cabinda' },
  { src: dois, title: 'Manutenção de ar condicionado - Jinga Shopping' },
  { src: tres, title: 'Jardinagem - Bengo' },
  { src: quatro, title: 'Sistema electrico - condominio nosso zimbo' },
];

const tecnologiaImages = [
  { src: umti, title: 'Escola de Buco Zau - Cabinda' },
  { src: doisti, title: 'Escola Futila - Cabinda' },
  { src: tresti, title: 'Centro de Formação de Águas - Onga Zanga' },
  { src: quatroti, title: 'Laboratório do Caio - Cabinda' },
];

const allImages = [...manutencaoImages, ...tecnologiaImages];

const Projects = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleImageClick = (index) => {
    setSelectedIndex(index);
    setShowModal(true);
  };

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev - 1 + allImages.length) % allImages.length);
  };

  const handleNext = () => {
    setSelectedIndex((prev) => (prev + 1) % allImages.length);
  };

  const renderImageGrid = (images, offset = 0) => (
    <div className="image-grid">
      {images.map((img, index) => (
        <div
          className="image-card"
          key={index}
          onClick={() => handleImageClick(index + offset)}
        >
          <div className="image-wrapper">
            <img src={img.src} alt={img.title} />
            <div className="overlay">
              <FaSearch className="search-icon" />
            </div>
          </div>
          <div className="image-description">{img.title}</div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="projects-section">
      <h2 className="projects-title" style={{marginTop:"100px"}} >Building Maintenance</h2>
      {renderImageGrid(manutencaoImages, 0)}

      <h2 className="projects-title">Information Technology</h2>
      {renderImageGrid(tecnologiaImages, manutencaoImages.length)}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdrop={true}
        backdropClassName="transparent-backdrop"
        centered
        size="lg"
        className="modal-fullscreen"
      >
        <Modal.Body className="custom-modal-body">
          <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
          <button className="modal-arrow left" onClick={handlePrev}>
            <FaChevronLeft />
          </button>
          <div className="modal-content-wrapper">
            <img
              src={allImages[selectedIndex]?.src}
              alt={allImages[selectedIndex]?.title}
              className="modal-image"
            />
            <div className="modal-caption">{allImages[selectedIndex]?.title}</div>
          </div>
          <button className="modal-arrow right" onClick={handleNext}>
            <FaChevronRight />
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Projects;
